import { animate, state, style, transition, trigger } from '@angular/animations';

export const OverlayAnimations = trigger('fadeOverlay', [
    state(
        'open',
        style({
            opacity: 1,
            display: 'flex',
        })
    ),
    state(
        'closed',
        style({
            opacity: 0,
            display: 'none',
        })
    ),
    transition('open => closed, closed => open', [animate('0.2s')]),
]);

export const ToggleContentAnimations = trigger('toggleContent', [
    state(
        'open',
        style({
            width: '372px',
            opacity: 1,
            display: 'flex',
        })
    ),
    state(
        'closed',
        style({
            width: '0px',
            display: 'none',
        })
    ),
    transition('open => closed, closed => open', [animate('0.2s')]),
]);
